<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">检测数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <el-tabs type="border-card" :before-leave='beforeLeave' v-model="activeName"
                 style="height:350px">
          <el-tab-pane v-for="(item,i) in tableData" :key="i" :label="item.name">
            <component :is="item.currentRole" ref="component"/>
          </el-tab-pane>
        </el-tabs>

      </div>

    </div>


    <DataXueYa ref="myDataXueYa" v-show="false"></DataXueYa>
    <DataDanGuChun v-show="false"></DataDanGuChun>
    <DataNiaoSuan  v-show="false"></DataNiaoSuan>
    <DataXueYang  v-show="false"></DataXueYang>
    <DataXueHongDanBai  v-show="false"></DataXueHongDanBai>
    <DataNiaoChangGui  v-show="false"></DataNiaoChangGui>
    <DataXueZhi  v-show="false"></DataXueZhi>
    <DataXueTang  v-show="false"></DataXueTang>

    <DataTangHuaXueHongDanBai  v-show="false"></DataTangHuaXueHongDanBai>
    <DataBmi  v-show="false"></DataBmi>
    <DataTiWen  v-show="false"></DataTiWen>
    <DataShengHua  v-show="false"></DataShengHua>
    <DataGuMiDu  v-show="false"></DataGuMiDu>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5_with_china} from "@/common/Base64MD5";

import DataXueYa from "./DataXueYa";
import DataDanGuChun from "./DataDanGuChun";
import DataNiaoSuan from "./DataNiaoSuan";
import DataXueYang from "./DataXueYang";
import DataXueHongDanBai from "./DataXueHongDanBai";
import DataNiaoChangGui from "./DataNiaoChangGui";
import DataXueZhi from "./DataXueZhi";
import DataXueTang from "./DataXueTang";

import DataTangHuaXueHongDanBai from "./DataTangHuaXueHongDanBai";
import DataBmi from "./DataBmi";
import DataTiWen from "./DataTiWen";
import DataShengHua from "./DataShengHua";
import DataGuMiDu from "./DataGuMiDu";

export default {
  name: 'Data',
  data() {
    return {

      idCard:'',

      result:null,

      activeName:'0',
      tableData: [
        {name: '血压',currentRole:'DataXueYa',isNone:false},
        {name: '总胆固醇',currentRole:'DataDanGuChun',isNone:false},
        {name: '尿酸',currentRole:'DataNiaoSuan',isNone:false},
        {name: '血氧',currentRole:'DataXueYang',isNone:false},
        {name: '血红蛋白',currentRole:'DataXueHongDanBai',isNone:false},
        {name: '尿常规',currentRole:'DataNiaoChangGui',isNone:false},
        {name: '血脂',currentRole:'DataXueZhi',isNone:false},
        {name: '血糖',currentRole:'DataXueTang',isNone:false},
        {name: '糖化血红蛋白',currentRole:'DataTangHuaXueHongDanBai',isNone:false},
        {name: 'Bmi',currentRole:'DataBmi',isNone:false},
        {name: '体温',currentRole:'DataTiWen',isNone:false},
        {name: '生化',currentRole:'DataShengHua',isNone:false},
        {name: '骨密度',currentRole:'DataGuMiDu',isNone:false},
      ],

      bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
      th:this.$store.state.tableHeight,
    }
  },
  components: {
    DataXueYa,DataDanGuChun,DataNiaoSuan,DataXueYang,DataXueHongDanBai,DataNiaoChangGui,
    DataXueZhi,DataXueTang,DataTangHuaXueHongDanBai,DataBmi,DataTiWen,DataShengHua,
    DataGuMiDu
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val
    },
  },
  methods: {

    init(idCard){
      this.idCard = idCard;
      this.getData2()

      this.activeName='0'
      this.tableData.forEach((item)=>{
        item.isNone=false
      })

    },



    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    closeSelf() {
      this.$emit("closeData");
    },

    getTime(row,index,column){
      return timefilters(column)
    },

    beforeLeave(activeName){
      if(!this.tableData[parseInt(activeName)].isNone){
        this.tableData[parseInt(activeName)].isNone=true
        this.$nextTick(() => {
          this.$refs.component[parseInt(activeName)].init(this.result);
        })
      }
    },

    getData2(){
      var _this=this
      this.tableLoading=true

      let data = {
        timeStr: timeStr,
        sign: "",
        idCard: this.idCard,
      };


      data.sign = "";
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: "post",
        url: this.$deviceUrl + "GroupGarea/ListByIdCard",
        data: data,
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {

          let rv = response.data.data.rv;
          //console.log(rv);

          let obj = JSON.parse(rv);
          _this.result = obj.result;

          this.$nextTick(() => {
            this.$refs.component[parseInt(_this.activeName)].init(_this.result);
          })

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },



  }
}


</script>


